import axios from '../../app/axiosConfig';

export const getShopsReq = (data = {}) => {
  return axios.get('/shops', data);
};
